import {create} from "zustand";

export const useArticleStore = create((set) => ({
    /**
     * Выбранная категория
     */
    categoryId: 1,

    /**
     * Активная страница, используется для запроса на сервер (пагинация)
     * @type {number}
     */
    page: 1,

    /**
     * Инициализация данных
     * @param categoryId
     */
    initData: ({categoryId = 1, page = 1}) => {
        set({
            categoryId,
            page
        });
    },
}));
